import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../../../../components/layout/Layout';

interface Acao {
  id: number;
  nome: string;
  descricao: string;
  pontos: number;
  tipo: string;
  frequencia: string;
  ativa: boolean;
}

export default function AcoesPage() {
  const navigate = useNavigate();
  const [showAddModal, setShowAddModal] = useState(false);
  const [acoes, setAcoes] = useState<Acao[]>([
    {
      id: 1,
      nome: 'Venda Realizada',
      descricao: 'Pontos por cada venda concluída',
      pontos: 100,
      tipo: 'vendas',
      frequencia: 'ilimitada',
      ativa: true
    },
    {
      id: 2,
      nome: 'Novo Cliente Cadastrado',
      descricao: 'Pontos por cadastro de novo cliente',
      pontos: 50,
      tipo: 'aquisicao',
      frequencia: 'ilimitada',
      ativa: true
    },
    {
      id: 3,
      nome: 'Meta Mensal Atingida',
      descricao: 'Bônus por atingir a meta do mês',
      pontos: 500,
      tipo: 'performance',
      frequencia: 'mensal',
      ativa: true
    }
  ]);

  const [novaAcao, setNovaAcao] = useState({
    nome: '',
    descricao: '',
    pontos: 0,
    tipo: '',
    frequencia: 'ilimitada'
  });

  const handleAddAcao = () => {
    try {
      if (novaAcao.nome && novaAcao.pontos > 0 && novaAcao.tipo) {
        const novaAcaoCompleta: Acao = {
          ...novaAcao,
          id: Date.now(),
          ativa: true
        };
        setAcoes([...acoes, novaAcaoCompleta]);
        setNovaAcao({ nome: '', descricao: '', pontos: 0, tipo: '', frequencia: 'ilimitada' });
        setShowAddModal(false);
      } else {
        // Optionally add error feedback for user
        console.warn('Por favor, preencha todos os campos obrigatórios');
      }
    } catch (error) {
      console.error('Erro ao adicionar ação:', error);
    }
  };

  const toggleAcao = (id: number) => {
    setAcoes(acoes.map(acao => 
      acao.id === id ? { ...acao, ativa: !acao.ativa } : acao
    ));
  };

  const handleRemoveAcao = (id: number) => {
    setAcoes(acoes.filter(acao => acao.id !== id));
  };

  const getTipoColor = (tipo: string) => {
    const colors: Record<string, string> = {
      'vendas': 'bg-blue-100 text-blue-800',
      'aquisicao': 'bg-emerald-100 text-emerald-800',
      'performance': 'bg-orange-100 text-orange-800',
      'engajamento': 'bg-purple-100 text-purple-800'
    };
    return colors[tipo] || 'bg-gray-100 text-gray-800';
  };

  const getTipoLabel = (tipo: string) => {
    const labels: Record<string, string> = {
      'vendas': 'Vendas',
      'aquisicao': 'Aquisição',
      'performance': 'Performance',
      'engajamento': 'Engajamento'
    };
    return labels[tipo] || tipo;
  };

  const handleProximo = () => {
    navigate('/admin/incentivo/campanhas/regras');
  };

  return (
    <Layout>
      <div className="space-y-6">
        {/* Header */}
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Ações e Pontos</h1>
            <p className="text-gray-600 mt-1">Configure as ações que geram pontos na campanha</p>
          </div>
          <button
            onClick={() => setShowAddModal(true)}
            className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg flex items-center space-x-2 transition-colors cursor-pointer whitespace-nowrap"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-add-line"></i>
            </div>
            <span>Adicionar Ação</span>
          </button>
        </div>

        {/* Progress Steps */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-2">
              <div className="w-8 h-8 rounded-full bg-emerald-600 text-white flex items-center justify-center">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-check-line"></i>
                </div>
              </div>
              <span className="text-gray-600">Dados Básicos</span>
            </div>
            <div className="flex-1 h-1 bg-emerald-600 mx-4"></div>
            <div className="flex items-center space-x-2">
              <div className="w-8 h-8 rounded-full bg-emerald-600 text-white flex items-center justify-center">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-check-line"></i>
                </div>
              </div>
              <span className="text-gray-600">Objetivos</span>
            </div>
            <div className="flex-1 h-1 bg-blue-600 mx-4"></div>
            <div className="flex items-center space-x-2">
              <div className="w-8 h-8 rounded-full bg-blue-600 text-white flex items-center justify-center font-semibold">
                3
              </div>
              <span className="font-semibold text-gray-900">Ações</span>
            </div>
            <div className="flex-1 h-1 bg-gray-200 mx-4"></div>
            <div className="flex items-center space-x-2">
              <div className="w-8 h-8 rounded-full bg-gray-200 text-gray-600 flex items-center justify-center font-semibold">
                4
              </div>
              <span className="text-gray-600">Regras</span>
            </div>
            <div className="flex-1 h-1 bg-gray-200 mx-4"></div>
            <div className="flex items-center space-x-2">
              <div className="w-8 h-8 rounded-full bg-gray-200 text-gray-600 flex items-center justify-center font-semibold">
                5
              </div>
              <span className="text-gray-600">Premiação</span>
            </div>
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-600">Total de Ações</p>
                <p className="text-2xl font-bold text-gray-900 mt-2">{acoes.length}</p>
              </div>
              <div className="w-12 h-12 rounded-lg bg-blue-600 flex items-center justify-center">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-flashlight-line text-white text-xl"></i>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-600">Ações Ativas</p>
                <p className="text-2xl font-bold text-gray-900 mt-2">{acoes.filter(a => a.ativa).length}</p>
              </div>
              <div className="w-12 h-12 rounded-lg bg-emerald-500 flex items-center justify-center">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-checkbox-circle-line text-white text-xl"></i>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-600">Pontos Totais</p>
                <p className="text-2xl font-bold text-gray-900 mt-2">{acoes.reduce((sum, a) => sum + a.pontos, 0)}</p>
              </div>
              <div className="w-12 h-12 rounded-lg bg-orange-500 flex items-center justify-center">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-coin-line text-white text-xl"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Acoes List */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">Ações Configuradas</h3>
          
          {acoes.length === 0 ? (
            <div className="text-center py-12">
              <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-flashlight-line text-gray-400 text-2xl"></i>
                </div>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Nenhuma ação configurada</h3>
              <p className="text-gray-600 mb-4">Adicione ações para definir como os participantes ganham pontos</p>
              <button
                onClick={() => setShowAddModal(true)}
                className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
              >
                Adicionar Primeira Ação
              </button>
            </div>
          ) : (
            <div className="space-y-4">
              {acoes.map((acao) => (
                <div key={acao.id} className={`border rounded-lg p-4 transition-all ${acao.ativa ? 'border-gray-200 bg-white' : 'border-gray-200 bg-gray-50 opacity-60'}`}>
                  <div className="flex items-start justify-between">
                    <div className="flex-1">
                      <div className="flex items-center space-x-3 mb-2">
                        <h4 className="text-base font-semibold text-gray-900">{acao.nome}</h4>
                        <span className={`px-2 py-1 rounded-full text-xs font-medium ${getTipoColor(acao.tipo)}`}>
                          {getTipoLabel(acao.tipo)}
                        </span>
                        {!acao.ativa && (
                          <span className="px-2 py-1 rounded-full text-xs font-medium bg-gray-200 text-gray-700">
                            Inativa
                          </span>
                        )}
                      </div>
                      <p className="text-sm text-gray-600 mb-3">{acao.descricao}</p>
                      
                      <div className="flex items-center space-x-6">
                        <div className="flex items-center space-x-2">
                          <div className="w-4 h-4 flex items-center justify-center">
                            <i className="ri-coin-line text-orange-600"></i>
                          </div>
                          <span className="text-sm font-semibold text-gray-900">{acao.pontos} pontos</span>
                        </div>
                        <div className="flex items-center space-x-2">
                          <div className="w-4 h-4 flex items-center justify-center">
                            <i className="ri-repeat-line text-blue-600"></i>
                          </div>
                          <span className="text-sm text-gray-600 capitalize">{acao.frequencia}</span>
                        </div>
                      </div>
                    </div>
                    
                    <div className="flex items-center space-x-2 ml-4">
                      <button
                        onClick={() => toggleAcao(acao.id)}
                        className={`px-3 py-1 rounded-lg text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                          acao.ativa 
                            ? 'bg-emerald-100 text-emerald-800 hover:bg-emerald-200' 
                            : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                        }`}
                      >
                        {acao.ativa ? 'Ativa' : 'Inativa'}
                      </button>
                      <button
                        onClick={() => handleRemoveAcao(acao.id)}
                        className="text-red-600 hover:text-red-800 cursor-pointer p-2"
                      >
                        <div className="w-5 h-5 flex items-center justify-center">
                          <i className="ri-delete-bin-line"></i>
                        </div>
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Add Acao Modal */}
        {showAddModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg p-6 w-full max-w-md mx-4">
              <div className="flex items-center justify-between mb-6">
                <h3 className="text-lg font-semibold text-gray-900">Adicionar Ação</h3>
                <button
                  onClick={() => setShowAddModal(false)}
                  className="text-gray-400 hover:text-gray-600 cursor-pointer"
                >
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-close-line text-xl"></i>
                  </div>
                </button>
              </div>

              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Nome da Ação</label>
                  <input
                    type="text"
                    value={novaAcao.nome}
                    onChange={(e) => setNovaAcao({ ...novaAcao, nome: e.target.value })}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                    placeholder="Ex: Venda Realizada"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Descrição</label>
                  <textarea
                    value={novaAcao.descricao}
                    onChange={(e) => setNovaAcao({ ...novaAcao, descricao: e.target.value })}
                    rows={3}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                    placeholder="Descreva a ação..."
                  ></textarea>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Tipo</label>
                  <select
                    value={novaAcao.tipo}
                    onChange={(e) => setNovaAcao({ ...novaAcao, tipo: e.target.value })}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm pr-8"
                  >
                    <option value="">Selecione o tipo</option>
                    <option value="vendas">Vendas</option>
                    <option value="aquisicao">Aquisição</option>
                    <option value="performance">Performance</option>
                    <option value="engajamento">Engajamento</option>
                  </select>
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Pontos</label>
                    <input
                      type="number"
                      value={novaAcao.pontos}
                      onChange={(e) => setNovaAcao({ ...novaAcao, pontos: Number(e.target.value) })}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                      placeholder="0"
                      min="0"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Frequência</label>
                    <select
                      value={novaAcao.frequencia}
                      onChange={(e) => setNovaAcao({ ...novaAcao, frequencia: e.target.value })}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm pr-8"
                    >
                      <option value="ilimitada">Ilimitada</option>
                      <option value="diaria">Diária</option>
                      <option value="semanal">Semanal</option>
                      <option value="mensal">Mensal</option>
                      <option value="unica">Única</option>
                    </select>
                  </div>
                </div>

                <div className="flex items-center justify-end space-x-3 pt-4">
                  <button
                    onClick={() => setShowAddModal(false)}
                    className="px-4 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
                  >
                    Cancelar
                  </button>
                  <button
                    onClick={handleAddAcao}
                    className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors cursor-pointer whitespace-nowrap"
                  >
                    Adicionar
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Action Buttons */}
        <div className="flex items-center justify-between">
          <button className="px-6 py-2 text-gray-700 bg-white border border-gray-300 hover:bg-gray-50 rounded-lg transition-colors cursor-pointer whitespace-nowrap flex items-center space-x-2">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-left-line"></i>
            </div>
            <span>Voltar: Objetivos e Metas</span>
          </button>
          <button 
            onClick={handleProximo}
            className="px-6 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors cursor-pointer whitespace-nowrap flex items-center space-x-2"
          >
            <span>Próximo: Regras</span>
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </button>
        </div>
      </div>
    </Layout>
  );
}
